export default __webpack_public_path__ + "static/0212-55971fae5e558a183c755edd80254eb3.png";